import React, { useContext, useCallback } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { FormContext } from "../../util/context";
import { Button } from "@material-ui/core";
import Airtable from "airtable";
import { useHistory } from "react-router-dom";

const Submit = () => {
  const [form, setForm] = useContext(FormContext);
  const base = new Airtable({ apiKey: process.env.REACT_APP_AIRTABLE }).base(
    "appj1Vr79A45j6ebS"
  );
  const history = useHistory();

  const sendData = useCallback(async () => {
    base("Table 1").create(
      {
        "Sex": form.gender,
        "Category": form.professionArray,
        "Hours Sitting": form.hoursSitting,
        "Athlete Type": form.sportType,
        "Sports Played": form.sportsPlayed,
        "Exercise Frequency": form.exerciseFrequency,
        "Cannabis Consumption": form.cannabis,
        "Alcohol Consumption": form.alcohol,
        "Tobacco Consumption": form.tobacco,
        "Recreational Drugs": form.recreationalDrugs,
        "Stress Levels": form.stress,
        "Anxiety Levels": form.anxiety,
        "Irritability Levels": form.irritability,
        "Energy Levels": form.energy,
        "Daily Routine Consistency": form.dailyRoutine,
        "Sleep Schedule Consistency": form.sleepRating,
        "Hours of sleep": form.hoursSleep,
        "Neurodiversities": form.neurodiversities,
        "Height": form.height,
        "Weight": form.weight,
        "Number of Concussions": form.concussionNumber,
        "Concussion History": form.concussionHistory,
        "Age Group": form.dob,
        "Email": form.email,
      },
      { typecast: true },
      function (err, record) {
        if (err) {
          console.error(err);
          return;
        }
        console.log(record.getId());
        history.push("/bookappt2");
      }
    );
  }, [base, form, history]);

  return (
    <>
      <Container maxWidth="sm">
        <Box alignContent="center">
          <Typography align="center" component={"span"} variant="h4">
            Click to Submit your Information.
          </Typography>
        </Box>
        <Box mt={5}>
          <Container maxWidth="md">
            <Grid container={true} spacing={2}>
              <Grid item={true} xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={sendData}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Container>
    </>
  );
};

export default Submit;
